import { useCallback, useEffect, useMemo, useState } from 'react';
import { useGlobalStore } from '@core/hooks/useGlobalStore';
import { useContextTranslation } from '@core/i18n';
import { productsLoadedCallbackSelector } from '@core/shopping/model';
import { PRODUCT_CARD_CAROUSEL_CHEVRON_DOWN_BUTTON, PRODUCT_CARD_CAROUSEL_CHEVRON_UP_BUTTON, } from '@src/core/components/testIds';
import { useTrackToggleProduct } from '../useTrackToggleProduct';
import { ChevronDownButton } from './ChevronDownButton';
import { ChevronUpButton } from './ChevronUpButton';
import { ProductList, ProductListWrapper, ToggleButtonContainer, } from './PlayerDeckContainer.styles';
import { ProductCardItem } from './ProductCardItem';
/**
 * Product List
 */
export const ProductListContainer = ({ video, onCardVisibilityChange, }) => {
    const onProductsLoaded = useGlobalStore(productsLoadedCallbackSelector);
    const [products, setProducts] = useState([]);
    useEffect(() => {
        if (onProductsLoaded) {
            onProductsLoaded({ video, products: video?.products }).then((productsFromCb) => {
                setProducts(productsFromCb ?? []);
            });
        }
        else {
            setProducts(video?.products ?? []);
        }
    }, [onProductsLoaded, setProducts, video]);
    const [showAllProducts, setShowAllProducts] = useState(false);
    const { t } = useContextTranslation();
    const videoHasMultipleProducts = products?.length > 1 || false;
    const trackToggleProductList = useTrackToggleProduct(video);
    const toggleProducts = useCallback(() => {
        setShowAllProducts(!showAllProducts);
        trackToggleProductList(products, !showAllProducts);
    }, [products, showAllProducts, trackToggleProductList]);
    const visibilityCallbacks = useMemo(() => {
        return products.map((product) => {
            return (isVisible) => {
                onCardVisibilityChange?.(isVisible, product);
            };
        });
    }, [onCardVisibilityChange, products]);
    if (!products) {
        return null;
    }
    return (<ProductListWrapper showAllProducts={showAllProducts} hasMultipleProducts={videoHasMultipleProducts}>
      {videoHasMultipleProducts && (<ToggleButtonContainer>
          <>
            {showAllProducts ? (<ChevronDownButton data-testid={PRODUCT_CARD_CAROUSEL_CHEVRON_DOWN_BUTTON} onClick={toggleProducts} aria-label={t('Hide All Products')}/>) : (<ChevronUpButton data-testid={PRODUCT_CARD_CAROUSEL_CHEVRON_UP_BUTTON} onClick={toggleProducts} aria-label={t('Show All Products')}/>)}
          </>
        </ToggleButtonContainer>)}
      <ProductList>
        {products
            .slice(0, showAllProducts ? products.length : 1)
            .map((product, index) => (<ProductCardItem key={product.id} product={product} onVisibilityChange={visibilityCallbacks[index]} video={video}/>))}
      </ProductList>
    </ProductListWrapper>);
};
